const LOCALE_SR_LATN = {
	// Core
	setText: "U redu",
	cancelText: "Otkaži",
	clearText: "Obriši",
	selectedText: "{count} izabrano",
	// Datetime component
	dateFormat: "D. M. YYYY.",
	dateFormatLong: "D. MMMM YYYY.",
	dayNames: ["Nedelja", "Ponedeljak", "Utorak", "Sreda", "Četvrtak", "Petak", "Subota"],
	dayNamesShort: ["Ned", "Pon", "Uto", "Sre", "Čet", "Pet", "Sub"],
	dayNamesMin: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
	dayText: "Dan",
	delimiter: ".",
	hourText: "Sat",
	minuteText: "Minut",
	monthNames: [
		"Januar",
		"Februar",
		"Mart",
		"April",
		"Maj",
		"Jun",
		"Jul",
		"Avgust",
		"Septembar",
		"Oktobar",
		"Novembar",
		"Decembar",
	],
	monthNamesShort: [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"Maj",
		"Jun",
		"Jul",
		"Avg",
		"Sep",
		"Okt",
		"Nov",
		"Dec",
	],
	monthText: "Mesec",
	secText: "Sekunda",
	timeFormat: "H:mm",
	yearText: "Godina",
	nowText: "Sada",
	pmText: "po podne",
	amText: "pre podne",
	// Calendar component
	firstDay: 1,
	dateText: "Datum",
	timeText: "Vreme",
	todayText: "Danas",
	prevMonthText: "Prethodni mesec",
	nextMonthText: "Sledeći mesec",
	prevYearText: "Prethodna godina",
	nextYearText: "Sledeća godina",
	closeText: "Zatvori",
	eventText: "događaj",
	eventsText: "događaji",
	allDayText: "Ceo dan",
	noEventsText: "Nema događaja",
	moreEventsText: "{count} više",
};

const LOCALE_BS_LATN = {
	setText: "OK",
	cancelText: "Odustani",
	clearText: "Obriši",
	closeText: "Zatvori",
	selectedText: "{count} odabrano",
	dateFormat: "DD.MM.YYYY",
	dateFormatFull: "DDDD, D. MMMM YYYY",
	dateFormatLong: "DDD. D. MMM. YYYY",
	dateWheelFormat: "|DDD. D. MMM.|",
	dayNames: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"],
	dayNamesShort: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
	dayNamesMin: ["N", "P", "U", "S", "Č", "P", "S"],
	dayText: "Dan",
	hourText: "Sat",
	minuteText: "Minuta",
	fromText: "Od",
	monthNames: [
		"Januar",
		"Februar",
		"Mart",
		"April",
		"Maj",
		"Juni",
		"Juli",
		"August",
		"Septembar",
		"Oktobar",
		"Novembar",
		"Decembar",
	],
	monthNamesShort: [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"Maj",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Okt",
		"Nov",
		"Dec",
	],
	monthText: "Mjesec",
	secondText: "Sekunde",
	timeFormat: "HH:mm",
	yearText: "Godina",
	nowText: "Sada",
	pmText: "pm",
	amText: "am",
	todayText: "Danas",
	toText: "Do",
	firstDay: 1,
	dateText: "Datum",
	timeText: "Vrijeme",
	allDayText: "Cijeli dan",
	noEventsText: "Nema događaja",
	eventText: "Događaj",
	eventsText: "Događaji",
	moreEventsText: "{count} dodatni događaj",
	moreEventsPluralText: "{count} dodatnih događaja",
	weekText: "Sedmica {count}",
	rangeStartLabel: "Od",
	rangeEndLabel: "Do",
	rangeStartHelp: "Odaberi",
	rangeEndHelp: "Odaberi",
	filterEmptyText: "Nema rezultata",
	filterPlaceholderText: "Pretraži",
};

export const CustomLangs: Record<string, any> = {
	"sr-Latn": LOCALE_SR_LATN,
	bs: LOCALE_BS_LATN,
};
